import { render, staticRenderFns } from "./FroalaWrapper.vue?vue&type=template&id=97f0f252&"
import script from "./FroalaWrapper.vue?vue&type=script&lang=js&"
export * from "./FroalaWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FroalaWrapper.vue?vue&type=style&index=0&id=97f0f252&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports